export const API_BASE = process.env.REACT_APP_BASE_URL;
export const ASSET_BASE = process.env.REACT_APP_ASSET_BASE_URL;

/**
 * Build a full URL for a server-stored asset (image, document, etc.).
 * - If path is already absolute (http/https), return it unchanged.
 * - Otherwise prefix with ASSET_BASE.
 */
export const assetUrl = (path) => {
  if (!path) return "";
  if (path.startsWith("http://") || path.startsWith("https://")) return path;
  return `${ASSET_BASE}${path}`;
};

/**
 * Same as assetUrl but forces the /storage/ sub-path prefix when the path
 * doesn't already include it (used for thumbnails stored in Laravel's storage).
 */
export const storageUrl = (path) => {
  if (!path) return "";
  if (path.startsWith("http://") || path.startsWith("https://")) return path;
  if (path.startsWith("storage/")) return `${ASSET_BASE}${path}`;
  return `${ASSET_BASE}storage/${path}`;
};
